import * as React from 'react';
import { FC } from 'react';
import Select from 'brand_xo/widgets/Select';
import type { OptionType } from 'brand_xo/widgets/Select';
import { useLocales } from './locales';

const ProviderFilter: FC<{
  value: string | undefined;
  onChange: (v: string) => void;
  providerInfos: OptionType[];
}> = ({ value, onChange, providerInfos }) => {
  const l = useLocales();

  return (
    <Select
      options={[{ label: l('all'), value: '' }, ...providerInfos]}
      value={value || ''}
      onChange={onChange}
      label={l('providers')}
      // The filter row out of sight (pinned_filters.js).
      closeOn="xo:filters-gone"
    />
  );
};

export default ProviderFilter;
